import React, {useState} from "react";
import {useSelector} from "react-redux"
import {toast} from "react-toastify";
import {Box, Input, FormControl, InputLabel, Button, Select, MenuItem} from "@mui/material";

import {PLAYER_TYPES} from "../../constants"
import {useAction, useTranslate} from "../../hooks";
import {validatePlayer} from "../../helpers";

const AddPlayerForm = ({hide}) => {
    const {players} = useSelector(state => state.player);
    const [formFields, setFormFields] = useState({
        name: "",
        inGameNumber: "",
        type: PLAYER_TYPES[0]
    });

    const translates = useTranslate();
    const {addPlayer} = useAction();

    const setFormField = (field, value) => {
        if(field === "inGameNumber" && !/^\d+$/.test(value) && value !== "") {
            return
        }
        setFormFields({...formFields, [field]: value.trimLeft()})
    };

    const onSubmitHandler = e => {
        e.preventDefault()
        const isValid = validatePlayer(formFields, players)
        if(isValid) {
            addPlayer(formFields)
            hide && hide()
        } else {
            toast(translates["ADD_PLAYER_ERROR"])
        }
    }

    return (
        <Box
            component="form"
            sx={{
                bgcolor: 'background.paper',
                boxShadow: 1,
                borderRadius: 2,
                p: 2,
                width: 480,
                margin: "auto",
                marginTop: 20
            }}
        >
            <FormControl fullWidth={true}>
                <InputLabel htmlFor="name" variant="filled">{translates['FORM_ADD_PLAYER_NAME_LABEL']}</InputLabel>
                <Input
                    autoFocus={true}
                    name='password'
                    autoComplete='off'
                    type='text'
                    value={formFields.name}
                    id="name"
                    color="primary"
                    sx={{
                        fontSize: 16
                    }}
                    onChange={(e) => {
                        const {value} = e.target;
                        setFormField("name", value)
                    }}
                />
            </FormControl>
            <FormControl fullWidth={true} sx={{ fontSize: 14, fontWeight: 700}}>
                <InputLabel htmlFor="inGameNumber" variant="filled">{translates['FORM_ADD_PLAYER_NUMBER_TEXT']}</InputLabel>
                <Input
                    name='password'
                    autoComplete='off'
                    type='text'
                    value={formFields.inGameNumber}
                    id="inGameNumber"
                    color="primary"
                    sx={{
                        fontSize: 16
                    }}
                    onChange={(e) => {
                        const {value} = e.target;
                        setFormField("inGameNumber", value)
                    }}
                />
            </FormControl>
            <FormControl fullWidth={true} sx={{mt: 3}}>
                <InputLabel htmlFor="type">
                    {translates['FORM_ADD_PLAYER_ROLE_TEXT']}
                </InputLabel>
                <Select
                    sx={{mt: 1.5}}
                    value={formFields.type}
                    id="type"
                    onChange={(e) => {
                        const {value} = e.target;
                        setFormField("type", value)
                    }}
                >
                    {PLAYER_TYPES.map(role => (
                        <MenuItem value={role} key={role}>
                            {translates[role]}
                        </MenuItem>
                    ))}
                </Select>
                <Button
                    fullWidth={true}
                    variant='contained'
                    type="submit"
                    sx={{
                        mt: 4
                    }}
                    onClick={onSubmitHandler}
                >
                    {translates['FORM_ADD_PLAYER_SUBMIT_TEXT']}
                </Button>
            </FormControl>
        </Box>
    )
}

export default AddPlayerForm